class RecommendedDuoCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    if (window.innerWidth <= 900) {
      return new window.KeenSlider(
        this.els.slides.element,
        {
          selector: this.els.slide.selector,
          defaultAnimation: {
            duration: 1500,
          },
          loop: false,
          mode: 'snap',
          centered: true,
          slides: {
            perView: 1.2,
            spacing: 7,
          },
        },
        [window.BAO.Carousel.useInitialised()],
      )
    }
  }
}

if (!customElements.get('recommended-duo-carousel')) {
  customElements.define('recommended-duo-carousel', RecommendedDuoCarousel)
}
